import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AutenticacaoService } from 'src/app/seguranca/autenticacao.service';
import { RenegociacaoCartaoService } from '../renegociacao-cartao.service';
import { ToastService } from 'src/app/shared/toast';
import { LoaderService } from 'src/app/shared/loader/loader.service';
import { AcordoCliente, CustomerDebtRenegociationData, Divida } from 'src/app/shared/models/customer-debt-renegociation';
import { RenegociacaoCartaoLoggerService } from '../renegociacao-cartao-logger.service';
import { AcaoRenegociacaoCartaoLoggerEnum, CondicaoPropostaEnum } from 'src/app/shared/models/renegociacao-cartao-logger-service.model';
import { ServicoCartaoIndisponivelError } from 'src/app/shared/models/servico-cartao-indisponivel.error';
import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';

@Component({
  selector: 'app-lista-cartoes-page',
  templateUrl: './lista-cartoes-page.component.html',
  styleUrls: ['./lista-cartoes-page.component.scss']
})
export class ListaCartoesPageComponent implements OnInit {
  dadosRenegociacaoCartao: CustomerDebtRenegociationData;
  hasOffers: boolean;

  constructor(
    private authService: AutenticacaoService,
    private renegociacaoCartaoService: RenegociacaoCartaoService,
    private toast: ToastService,
    private loaderService: LoaderService,
    private router: Router,
    private renegociacaoCartaoLoggerService: RenegociacaoCartaoLoggerService,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) { }

  ngOnInit(): void {
    this.googleAnalyticsService.pushPageViewEvent({
      page_name: '/renegocie/portal/servicos/cartao',
      page_template: 'renegocie'
    })

    this.buscarDadosRenegociacaoCartao();
  }

  async buscarDadosRenegociacaoCartao() {
    try {
      this.loaderService.start();
      this.dadosRenegociacaoCartao = await this.renegociacaoCartaoService.buscarDadosRenegociacaoCartao();
    } catch (error) {
      if (error instanceof ServicoCartaoIndisponivelError) {
        this.toast.show({ type: 'error', title: 'Serviço temporariamente indisponível.', text: 'Por favor, tente novamente mais tarde.' })
      } else {
        this.toast.show({ type: 'error', title: 'Erro ao buscar dados de renegociação de cartão.', text: 'Tente novamente mais tarde.' });
      }
      this.googleAnalyticsService.pushActionEvent({
        event: 'view_error',
        detail: error?.error?.message ?? 'Erro ao buscar dados de renegociação de cartão',
        context: 'portal reneg:em atraso'
      })
    } finally {
      this.loaderService.stop();
    }
  }

  get username() {
    return this.authService.autenticacao?.nomeCliente ?? '';
  }

  get debts() {
    return this.dadosRenegociacaoCartao?.dividasCliente?.flatMap(debt => debt.dividas) ?? [];
  }

  get acordos() {
    return (
      this.dadosRenegociacaoCartao?.acordosCliente?.flatMap(
        (acordo) => acordo
      ) ?? []
    );
  }

  get customerData() {
    return this.dadosRenegociacaoCartao?.contato;
  }

  get temPropostaDisponivel() {
    return this.debts.some(debt => debt.ofertasNegociacao.length > 0);
  }

  mascararNumeroCartao(debt: Divida | AcordoCliente) {
    return debt.idCartao
      .replace(/^0+/, '')
      .replace(/^(\d{4})\d{8}(\d{4})$/, '$1.xxxx.xxxx.$2');
  }

  verificarAcordoDisponivel(debt: Divida) {
    this.hasOffers = debt?.ofertasNegociacao?.length > 0;
    return this.hasOffers;
  }

  redirectFlowDebts(debt: Divida) {
    this.googleAnalyticsService.pushActionEvent({
      event: 'click',
      detail: 'visualizar proposta',
      context: 'portal reneg:em atraso'
    })

    this.renegociacaoCartaoService.debitoAtual = debt;

    this.renegociacaoCartaoService.salvarDebitIdAtual(debt.idDividaBradesco);

    this.router.navigateByUrl("/portal/renegociacao/cartao/lista-cartoes/propostas");

    this.enviarLogVisualizarPropostas(debt);
  }

  //TODO: Ajustar os tipos referente a acordo, está uma bagunça e precisar ser arrumado.
  redirectFlowAgreements(acordo: Divida | AcordoCliente) {
    this.googleAnalyticsService.pushActionEvent({
      event: 'click',
      detail: 'acompanhar acordo',
      context: 'portal reneg:em dia'
    })

    this.router.navigate([
      "/portal/renegociacao/cartao/lista-cartoes/acordo",
      acordo.idDividaBradesco,
    ]);

    this.enviarLogAcompanharAcordo(acordo as Divida);
  }

  enviarLogVisualizarPropostas(debt: Divida) {
    const dadosPropostas = debt.ofertasNegociacao.map((proposta) => ({
      condicao: proposta.plano > 1 ? CondicaoPropostaEnum.PARCELADO : CondicaoPropostaEnum.AVISTA,
      dataEntrada: debt.dataNegociacao,
      quantidadeParcelas: proposta.plano - 1,
      valorEntrada: proposta.valorEntrada,
      valorParcelas: proposta.valorParcela,
      valorTotalPlano: proposta.valorAcordo,
    }));

    this.renegociacaoCartaoLoggerService.enviarLogRenegociacaoCartao({
      actionLogger: AcaoRenegociacaoCartaoLoggerEnum.CARTAO_BRADESCO_CONSULTAR_PROPOSTA_ACTION,
      cartao: debt.idCartao,
      dividaId: debt.idDividaBradesco,
      dadosPropostas: dadosPropostas
    })
  }

  enviarLogAcompanharAcordo(acordo: Divida) {
    this.renegociacaoCartaoLoggerService.enviarLogRenegociacaoCartao({
      actionLogger: AcaoRenegociacaoCartaoLoggerEnum.CARTAO_BRADESCO_CONSULTAR_ACORDO_ACTION,
      cartao: acordo.idCartao,
      dividaId: acordo.idDividaBradesco
    })
  }
}
